// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export interface xRequestQuote {
    quoteItemsOnly: boolean;
}

const initialState: xRequestQuote = {
    quoteItemsOnly: false,
};

const reducer = {
    "xRequestQuote/SetQuoteOnlyProducts": (
        draft: Draft<xRequestQuote>,
        action: {
            quoteItemsOnly: boolean;
        },
    ) => {
        draft.quoteItemsOnly = action.quoteItemsOnly;
    },
};

const xRequestQuote = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xRequestQuote = xRequestQuote;

export type xRequestQuoteState = {
    xRequestQuote: xRequestQuote;
} & ApplicationState;
